import React, { useState } from 'react'
import { ContainerCreditApplication } from './ContainerCreditApplication'
import { ButtonFlowNext } from '../molecules/ButtonFlowNext'
import { BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { IDraftModel } from '../../../../models'

interface InputSingleMoneyValueNextProps {
  data: string
  onValue: (arg: string) => void
  document: IDraftModel
  noDecimal?: boolean
  allowZeroValue?: boolean
}

export const InputSingleMoneyValueNext: React.FC<InputSingleMoneyValueNextProps> =
  ({ data, onValue, document, allowZeroValue = false, noDecimal = false }) => {
    const { t } = useTranslation()
    const [value, setValue] = useState(data || '')
    return (
      <>
        <ContainerCreditApplication style={null}>
          <BtInput
            value={value}
            onChangeText={(val) => setValue(val)}
            style={{ textAlign: 'center' }}
            containerStyle={{
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderBottomWidth: 1,
              borderRadius: 0,
              borderBottomColor: 'rgba(200, 200, 200, 1)',
            }}
            maskType="money"
            maskOptions={{
              separator: '.',
              unit: '$',
              delimiter: ',',
              precision: noDecimal ? 0 : 2,
            }}
            validateInput={() => ''}
            toRemoveRegex={/[^\d.]+/g}
            placeholder={t('CreditApplication.PleaseEnterValue')}
          />
        </ContainerCreditApplication>
        <ButtonFlowNext
          containerStyle={{ marginTop: 40 }}
          disabled={
            (document?.type !== 'loan_application' && Number(value) < 1) ||
            (!allowZeroValue && value !== '' && Number(value) < 1)
          }
          onPress={() => onValue(value)}
          document={document}
        />
      </>
    )
  }
